import { encodeStateAsUpdate } from 'yjs';
import { getYdocFromHtmlContent } from './getYDocFromHtmlContent.js';

const getEmptyYdocBinaryState = () => {
  return encodeStateAsUpdate(getYdocFromHtmlContent(`<p></p>`));
};
const getYdocBinaryStateFromText = (text) => {
  if (!text) {
    return getEmptyYdocBinaryState();
  }
  return encodeStateAsUpdate(getYdocFromHtmlContent(`${text}`));
};

export { getEmptyYdocBinaryState, getYdocBinaryStateFromText };
//# sourceMappingURL=getEmptyYdocBinaryState.js.map
